import logOut from '../pages/auth/LogOut';
import dashboard from '../pages/dashboard/Dashboard';
import ResourceTrackerAdd from '../pages/development/resourceTracker/ResourceTrackerAdd';
import ResourceTrackerList from '../pages/development/resourceTracker/ResourceTrackerList';
import TaskTrackerAdd from '../pages/development/taskTracker/TaskTrackerAdd';
import TaskTrackerList from '../pages/development/taskTracker/TaskTrackerList';
import GroupList from '../pages/group/GroupList';
import ModuleList from '../pages/modules/ModuleList';
import PermissionList from '../pages/permission/PermissionList';
import subModulesList from '../pages/subModules/subModulesList';
import RoleListing from '../pages/roles/RoleListing';
import AddRole from '../pages/roles/addRole/AddRole'
import UserListing from '../pages/users/UserListing';
import LearningList from '../pages/development/learnings/LearningList';
import TrainingList from '../pages/development/trainings/TrainingList';
import TopicsList from '../pages/development/topics/TopicsList';
import ReleasesList from '../pages/development/releases/ReleasesList';
import ReleaseAdd from '../pages/development/releases/ReleaseAdd';
import TutorialList from '../pages/development/tutorial/TutorialList';
import TutorialAdd from '../pages/development/tutorial/TutorialAdd';
import SectionsList from '../pages/development/sections/SectionsList';
import SectionAdd from '../pages/development/sections/SectionAdd';
import FeedbackListing from '../pages/support/feedback/FeedbackListing';
import MomListing from '../pages/support/mom/MomListing';
import MomAdd from '../pages/support/mom/MomAdd';
import IOTServiceProvider from '../pages/iotServiceProvider/IOTServiceProvider';
import ManufacturerList from '../pages/asset/manufacturer/ManufacturerList';
import ManufacturerAdd from '../pages/asset/manufacturer/ManufacturerAdd';
import ModelList from '../pages/asset/Model/ModelList';
import ModelAdd from '../pages/asset/Model/ModelAdd';
import SectionList from '../pages/asset/section/SectionList';
import AddSection from '../pages/asset/section/AddSection';
import SubSectionList from '../pages/asset/subsection/SubSectionList';
import SubSectionAdd from '../pages/asset/subsection/SubSectionAdd';
import AssetTypeList from '../pages/asset/assetType/AssetTypeList';
import AssetMatrixList from '../pages/asset/assetMatrix/AssetMatrixList';
import ChangeAssetCounterLogMeter from '../pages/asset/ChangeAssetCounterLogMeter/ChangeAssetCounterLogMeter';
import NewGroupList from '../pages/group/NewGroupList';


import ChangeAssetMatrixs from '../pages/asset/ChangeAssetMatrix/ChangeAssetMatrixs';
import AssetMatrixListing from '../pages/asset/ChangeAssetMatrix/AssetMatrixListing';
import AssetCounterLogMeterList from '../pages/asset/ChangeAssetCounterLogMeter/AssetCounterLogMeterList';
import AssetTypeAdd from '../pages/asset/assetType/AssetTypeAdd';
import AssetSCSList from '../pages/asset/assetSCS/AssetSCSList';
import AssetSCSAdd from '../pages/asset/assetSCS/AssetSCSAdd';
import AddAssetMatrix from '../pages/asset/assetMatrix/AddAssetMatrix';
import DeviceData from '../pages/iot/DeviceData';
import DeviceHistory from '../pages/iot/DeviceHistory';
import TripSessionDetail from '../pages/iot/TripSessionDetail';
import ConslidatedTripDetails from '../pages/iot/ConslidatedTripDetails';
import DeviceListing from '../pages/iot/Devicedata/DeviceListing';
import AddDevice from '../pages/iot/Devicedata/AddDevice';
import ManufacturerListing from '../pages/iot/ManufacturerData/ManufacturerListing';
import AddManufacturer from '../pages/iot/ManufacturerData/AddManufacturer';
import SimListing from '../pages/iot/SimData/SimListing';
import AddSimData from '../pages/iot/SimData/AddSimData';
import DeviceDataListing from '../pages/iot/DeviceListingData/DeviceDataListing';
import AddDeviceDataListing from '../pages/iot/DeviceListingData/AddDeviceDataListing';
import DeviceTypeList from '../pages/iot/DeviceType/DeviceTypeList';
import AddDeviceType from '../pages/iot/DeviceType/AddDeviceType';
import ModelListing from '../pages/iot/Model/ModelListing';
import IotModelAdd from '../pages/iot/Model/IotModelAdd';

export default [
    { path: '/dashboard', exact: true, name: "Dashboard", component: dashboard },
    { path: '/module_list', exact: true, name: "Module List", component: ModuleList },
    {path : '/sub_module_list', exact: true, name: "Sub Module", component: subModulesList},
    {path : '/permission_list', exact: true, name: "Permission", component: PermissionList},
    {path : '/group_list', exact: true, name: "Group List", component: GroupList},
    {path : '/new_group_list', exact: true, name: "Group List", component: NewGroupList},
    {path : '/task_tracker_list', exact: true, name: "Task Tracker", component: TaskTrackerList},
    {path : '/add_task', exact: true, name: "Task Tracker Add", component: TaskTrackerAdd},
    {path : '/resource_list', exact: true, name: "Resource List", component: ResourceTrackerList},
    {path : '/add_resource', exact: true, name: "Resource Add", component: ResourceTrackerAdd},
    {path : '/manufacturer_list', exact: true, name: "Manufacturer List", component: ManufacturerList},
    {path : '/add_manufacturer', exact: true, name: "Manufacturer Add", component: ManufacturerAdd},
    {path : '/model_list', exact: true, name: "Model List", component: ModelList},
    {path : '/add_model', exact: true, name: "Model Add", component: ModelAdd},
    {path : '/sections_list', exact: true, name: "Section List", component: SectionList},
    {path : '/add_section', exact: true, name: "Section Add", component: AddSection},
    {path : '/sub_section_list', exact: true, name: "Sub Section List", component: SubSectionList},
    {path : '/add_subsection', exact: true, name: "Sub Section Add", component: SubSectionAdd},
    {path : '/asset_type_list', exact: true, name: "Asset Type List", component: AssetTypeList},
    {path : '/asset_type_add', exact: true, name: "Asset Type Add", component: AssetTypeAdd},
    {path : '/asset_matrix_list', exact: true, name: "Asset Matrix List", component: AssetMatrixList},
    {path : '/asset_matrix_add', exact: true, name: "Asset Matrix Add", component: AddAssetMatrix},
   
    {path : '/roles', exact: true, name: "Role List", component: RoleListing},
    {path : '/add_role', exact: true, name: "Role Add", component: AddRole},
    {path : '/user_listing', exact: true, name: "User Listing", component: UserListing},
    {path : '/learning_list', exact: true, name: "Learning Listing", component: LearningList},
    {path : '/training_list', exact: true, name: "Training Listing", component: TrainingList},
    {path : '/topics_list', exact: true, name: "Topics", component: TopicsList},
    {path : '/releases_list', exact: true, name: "Topics", component: ReleasesList},
    {path : '/release_add', exact: true, name: "Release Add", component: ReleaseAdd},
    {path : '/tutorial_list', exact: true, name: "Tutorial List", component: TutorialList},
    {path : '/tutorial_add', exact: true, name: "Tutorial Add", component: TutorialAdd},
    {path : '/section_list', exact: true, name: "Section List", component: SectionsList},
    {path : '/section_add', exact: true, name: "Section List", component: SectionAdd},
    {path : '/feedback_list', exact: true, name: "Feedback List", component: FeedbackListing},
    {path : '/meeting_list', exact: true, name: "M.O.M List", component: MomListing},
    {path : '/meeting_add', exact: true, name: "M.O.M Add", component: MomAdd},
    {path : '/iot_service_provider', exact: true, name: "Header", component: IOTServiceProvider},
    // {path : '/header', exact: true, name: "Header", component: HeaderList},
    {path : '/logout', exact: true, name: "Logout", component: logOut},
  
    {path : '/change_asset_counterlog_meter', exact: true, name: "Change Asset Matrix", component: ChangeAssetCounterLogMeter},

    {path : '/change_asset_matrix', exact: true, name: "Change Asset Matrix", component: ChangeAssetMatrixs},
    {path : '/asset_matrix_listing', exact: true, name: "Change Asset Matrix", component: AssetMatrixListing},
    {path : '/counterlog_listing', exact: true, name: "Change Asset Matrix", component: AssetCounterLogMeterList},

    {path : '/asset_scs_list', exact: true, name: "Asset SCS List", component: AssetSCSList},
    {path : '/asset_scs_add', exact: true, name: "Asset SCS Add", component: AssetSCSAdd},
    {path : '/device_data', exact: true, name: "Device Data", component: DeviceData},
    {path : '/device_history', exact: true, name: "Device History ", component: DeviceHistory},

    {path : '/trip_details', exact: true, name: "Trip History", component: TripSessionDetail},
    {path : '/conslidate_trip_details', exact: true, name: "Conslidate Trip Details", component: ConslidatedTripDetails},
    {path : '/device_listing', exact: true, name: "Device Listing", component: DeviceListing},
    {path : '/add_device', exact: true, name: "Add Device", component: AddDevice},
    {path : '/manufacturer', exact: true, name: "Manufacturer Listing", component: ManufacturerListing},
    {path : '/manufacturer_add', exact: true, name: "Manufacturer Add", component: AddManufacturer},
    {path : '/sim', exact: true, name: "Sim Listing", component: SimListing},
    {path : '/sim_add', exact: true, name: "Add Sim", component: AddSimData},
    {path : '/device', exact: true, name: "Device Data Listing", component: DeviceDataListing},
    {path : '/device_add', exact: true, name: "Add Device Data", component: AddDeviceDataListing},
    {path : '/device_type', exact: true, name: "Device Type Listing", component: DeviceTypeList},
    {path : '/device_type_add', exact: true, name: "Add Device Type", component: AddDeviceType},
    {path : '/model', exact: true, name: "Manufacturer Listing", component: ModelListing},
    {path : '/model_add', exact: true, name: "Manufacturer Add", component: IotModelAdd},

]